import { getVocabulary } from "components/Vocabulary";
import { CustomFindingColumn } from "types/tenantConfig";

import { CellRenderers } from "./tableUtils";

export interface ColumnDef {
  key: string;
  getLabel: () => string;
  disabled?: boolean;
}

export const toWidgetOptions = (defs: ColumnDef[]) =>
  defs.map(({ key, getLabel, disabled }) => ({
    label: getLabel(),
    value: key,
    ...(disabled && { disabled: true }),
  }));

export const customColumnsToWidgetOptions = (
  customColumns: CustomFindingColumn[],
) =>
  customColumns.map((col) => ({
    label: col?.columnName,
    value: `keyValue.${col?.key}`,
  }));

export const generateOwnerColumn = (type: any) => {
  return {
    title: getVocabulary(type),
    width: 120,
    dataIndex: type,
    key: type,
    ellipsis: true,
    render: (_: any, record: any) =>
      CellRenderers.VALUE_OR_NA(
        record.teamDto?.[type]?.name || record[type + "Name"],
      ),
  };
};
